// @ts-strict-ignore
import { Directive, HostListener, Input, ViewContainerRef } from '@angular/core';
import { LMCtrlShiftClickEvent } from '@base/lm-ctrl-shift-click-event';
import { LMComponentInfoService } from '@services/lm-componentinfo.service';

@Directive()
export abstract class LMCtrlShiftClickBaseComponent {

  @Input() placeHolder: ViewContainerRef;

  @HostListener('click', [ '$event' ]) onClick(event) {
    if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
      // event.stopPropagation();
      this.addAdditionalInfo(event, this);

    }
  }
  public abstract getComponentInfo(): LMComponentInfo;

  protected constructor(
    protected lmComponentInfoService: LMComponentInfoService,
  ) {
  }

  public addAdditionalInfo(event: LMCtrlShiftClickEvent, component?: LMCtrlShiftClickBaseComponent): void {
    const info: LMComponentInfo = this.getComponentInfo();
    if (!((event.ctrlKey || event.metaKey) && event.shiftKey)) {
      return;
    }

    if (info && info.panelSpec) {
      const panelSpec: LMCompositePanelSpec = info.panelSpec;
      //  event.additionInfo = {'panelSpec': panelSpec};
      this.lmComponentInfoService.setPanelSpec(panelSpec);
    }

    if (info && info.contextFormSpec) {
      const contextFormSpec: LMFormSpec = info;
      //  event.additionInfo = {'contextFormSpec': contextFormSpec};
      this.lmComponentInfoService.setContextFormSpec(contextFormSpec);
    }

    if (info && info.cardviewSpec) {
    //  event.additionInfo = {'cardviewSpec': info.cardviewSpec};
      this.lmComponentInfoService.setCardviewSpec(info.cardviewSpec);
    }
  }
}
